<template>
    <div class="page-category page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">菜品分类管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>菜品管理</el-breadcrumb-item>
                            <el-breadcrumb-item>菜品分类管理</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleCategory('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <!-- <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>-->
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="name" label="分类名称：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.name" size="small" placeholder="分类名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable"
                                  :data="table_data.list"
                                  v-loading="table_data.loading"
                                  tooltip-effect="dark"
                                  :indent="3"
                                  style="width: 100%;text-align: center;"
                                  row-key="id"
                                  default-expand-all
                                  lazy
                                  @row-click="expandChange"
                                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                            <el-table-column prop="name" label="菜品分类名称" min-width="140">
                               
                            </el-table-column>

                            <el-table-column prop="remark" align="center" label="备注" min-width="120">
                            </el-table-column>
							<el-table-column prop="orderIndex" align="center" label="排序" min-width="120">
							</el-table-column>
                            <el-table-column prop="status" align="center" label="状态" min-width="90">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.statusText}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="right" label="操作" min-width="200" fixed="right">
                                <template slot-scope="scope">
                                    
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click.stop="handleCategory('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click.stop="deleteCategory(scope.row.icode)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export category-dialog" :title="dlg_category.title" :visible.sync="dlg_category.visible" width="534px" @close="closeCategory" :close-on-click-modal="false">
            <el-form ref="formCategory" :model="dlg_category.form" label-width="130px" :rules="dlg_category.rules" @submit.native.prevent>
                <el-form-item prop="name" style="margin-top: 15px;" label="菜品分类名称：" :error="dlg_category.error.name">
                    <el-input size="small" v-model="dlg_category.form.name" placeholder='请输入菜品分类名称' clearable></el-input>
                </el-form-item>
				<el-form-item prop="remark" style="margin-top: 15px;" label="备注：" :error="dlg_category.error.remark">
				    <el-input size="small" v-model="dlg_category.form.remark" placeholder='请输入菜品分类备注' clearable></el-input>
				</el-form-item>
                <el-form-item prop="orderIndex" label="排序：">
                    <el-input size="small" type='number' v-model="dlg_category.form.orderIndex" placeholder='请输入排序（输入数字）' clearable></el-input>
                </el-form-item>
                <el-form-item prop="status" label="状态：">
                    <el-radio-group v-model="dlg_category.form.status">
                        <el-radio v-for="(item, index) in dlg_category.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_category.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitCategory()" :loading="dlg_category.btn_loading">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                drawer: false,
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                //搜索
                form_search:{
                    // type:1,
                    name:'',
                  
                },
                init_data: {
                    status_list: [{id:-1, name: '全部'},{id:1, name: '开启'},{id:2, name: '禁用'}],
                },
                multipleSelection: [],
                paramNodes:{
                    tree:null,
                    treeNode:null,
                    resolve:null
                },
                table_data:{
                    loading: false,
                    list:[],
                    page_info:{
                        page: 1,
                        pageSize: 30,
                        total: 30,
                    },
                    current_list:[]
                },
                dlg_category:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    form:{
                       icode:'',
                        name:'',
						remark:'',
                        orderIndex:'',
                        status:1
                    },
                    error:{
                        name:'',
						remark:''
                    },
                    reset_form: {},
                    init_data:{
                      
                        status_list: [{id:1, name: '开启'},{id:0, name: '禁用'}]
                    },
                    rules:{
                        name:{required: true, message: '请输入分类名称', trigger: 'blur'},
                        status:{required: true, message: '请选择状态', trigger: ['change','blur']},
                        orderIndex:{required: true, message: '请输入排序（输入数字）', trigger: ['change','blur']}
                    }
                }
            }
        },
        created() {
            document.title = '菜品分类管理';
            this.dlg_category.reset_form = Object.assign({}, this.dlg_category.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.pageNo = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                this.$client.get('/api/biz/cook/type/getListForAdmin', params, function(res,message,total,totalPages){
                    _this.table_data.list = res;
					//_this.table_data.page_info.page = totalPages;
					_this.table_data.page_info.total = total;
                    
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            // loadCategory(tree, treeNode, resolve) {
            //     var _this = this;
            //     this.$client.get('/adminapi/productcategory/getdata', {id:tree.id}, function(res,message){
            //         _this.table_data.current_list = res.children_list;
            //         setTimeout(() => {
            //             resolve(_this.table_data.current_list);
            //         }, 1000)
            //     },function(res){

            //     });
            // },
            expandChange(row,index,e){
                this.$refs.multipleTable.store.loadOrToggle(row)
                this.$refs.multipleTable.toggleRowExpansion(row);
            },
      

            uploadSuccessImg(res, file, fileList){
                this.dlg_category.img_list = fileList;
                this.dlg_category.form.head_img = res.id;
                this.dlg_category.hide_upload = true;
            },
            removeImg(file, fileList){
                this.dlg_category.form.head_img = '';
                this.dlg_category.img_list = [];
                this.dlg_category.hide_upload = false;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的分类");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/productcategory/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },

            handleCategory(type,data){
                this.dlg_category.visible = true;
                if(type == 'add'){
                    this.dlg_category.title = '添加分类';
                    this.dlg_category.api = '/api/biz/cook/type/save';
                   
                }else{
                    this.dlg_category.form.icode= data.icode;
                    this.dlg_category.title = '编辑分类';
                    this.dlg_category.form.name = data.name;
                    this.dlg_category.form.remark = data.remark;
                    this.dlg_category.form.orderIndex = data.orderIndex;
                    this.dlg_category.form.status = data.status;
                    this.dlg_category.api = '/api/biz/cook/type/save';
                }
            },
            deleteCategory(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/api/biz/cook/type/delete', {id:id}, function(res,message){
                        _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
           
            submitCategory(){
                var _this = this;
                _this.$refs['formCategory'].validate((valid) => {
                    if (valid) {
                        this.dlg_category.btn_loading = true;
                        this.$client.post(this.dlg_category.api, this.dlg_category.form, function(res,message){
                            _this.$message(message);
                             _this.getList();
                            _this.dlg_category.btn_loading = false;
                            _this.dlg_category.visible = false;
                        }, function(message){
                            _this.dlg_category.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_category.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeCategory(){
                for(var key in this.dlg_category.form){
                    this.dlg_category.form[key] = this.dlg_category.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formCategory.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .el-drawer__header{
        margin-bottom: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #e9e9e9;
    }
    .el-drawer,.el-drawer__header,.el-drawer__header>:first-child{
        outline: none !important;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
    .page-category .el-upload--picture-card{
        line-height: 80px;
    }
    .page-category .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }

    .domain-dialog .el-form-item__label:before,.forward-dialog .el-form-item__label:before{
        display: none;
    }
    .approve-dialog .el-dialog__footer{
        text-align: center;
    }
    .error-dialog .el-dialog__header{
        border-bottom: none;
        padding-top: 25px;
        text-align: center;
    }
</style>
<style scoped>

</style>